// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"cardContent-module--cardContent--2-jd7"};